module.exports = __webpack_public_path__ + "img/bf1aa6c.png";